import { useEffect, useState, useCallback } from "react";
import { axiosClient } from "../api/proxy/AxiosClient";
import Schedule from "./Schedule";
import { useServices } from "../services/ServiceContext";
import { Grid2 } from "@mui/material";
import UserList from "./UserList";

export default function TeacherSchedule () {
  
  const [localSchedule, setLocalSchedule] = useState({ start: null, end: null });
  const { lesson } = useServices();
  const [lessons, setLessons] = useState([]);
  const [students, setStudents] = useState([]);
  const [events, setEvents] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [newLesson, setNewLesson] = useState(null);

  const user = JSON.parse(localStorage.getItem("user"));

  const fetchLessons = useCallback(async () => {
    try {
      const response = await axiosClient.get(`/lessons?teacherUid=${user.uid}`);
      setLessons(response.data);
    } catch (err) {
      console.error("Error fetching lessons:", err);
    }
  }, [ user.uid ]);

  const fetchStudents = useCallback(async () => {
    try {
      const response = await axiosClient.get(`/teachers/students`);
      setStudents(response.data);
    } catch (err) {
      console.error("Error fetching students:", err);
    }
  }, []);

  const buildEvents = useCallback(() => {
    try {
      const formattedEvents = lessons.map((lesson) => ({
        id: lesson.id,
        uid: lesson.uid,
        title: `[${lesson.name}]`,
        start: new Date(lesson.startDttm),
        end: new Date(lesson.endDttm),
        status: lesson.status,
        allDay: false,
        lesson,
        forSelectedUser: !selectedStudent || lesson.students.map(s => s.uid).includes(selectedStudent.uid)
      }));

      setEvents(formattedEvents);
    } catch (error) {
      console.error("Error building events:", error);
      return [];
    }
  }, [lessons, selectedStudent]);

  useEffect(() => {
    fetchLessons();
    fetchStudents();
  }, [ fetchLessons, fetchStudents ]);

  useEffect(() => {
    if (newLesson) {
      setLessons((prevLessons) => [...prevLessons, newLesson]);
    }
  }, [newLesson]);

  useEffect(() => {
    buildEvents();
  }, [lessons, selectedStudent, buildEvents]);

  const handleRangeSelected = (range) => {
    setLocalSchedule(range);
    lesson.openCreateLessonForTeacher(selectedStudent ? [selectedStudent] : [], students, range, setNewLesson);
  };

  const setChangedLesson = (updatedLesson) => {
    setLessons((prevLessons) => {
        if (updatedLesson.status === "deleted") {
          return prevLessons.filter((l) => l.id !== updatedLesson.id);
        } else {
          return prevLessons.map((l) => (l.id === updatedLesson.id ? updatedLesson : l));
        }
      }
    );
  }

  const viewEditLesson = (event) => {
    lesson.openEditLessonForTeacher(event.lesson, lessons, setChangedLesson);
  };

  return (
  <Grid2 container spacing={2} justifyContent="center">
    <UserList
      users={students}
      multiselect={false}
      typeIsActive={false}
      selectedUser={selectedStudent}
      handleSelectedUser={setSelectedStudent}
    />

    <Schedule
      start={localSchedule.start}
      end={localSchedule.end}
      onRangeSelected={handleRangeSelected}
      events={events}
      selectedUser={selectedStudent}
      onEventSelected={viewEditLesson}
    />
  </Grid2>
  );
}
